import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 34,
  medium: 25,
  small: 18,
  xSmall: 14
};
const CartEmptyIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.22998 5.79001H6.77605L7.24498 7.78801L26.5559 7.67627L23.2376 20.57H9.22391L5.98398 6.79001H2.22998V5.79001ZM25.263 8.68301L7.47998 8.78501L10.015 19.569H22.462L25.263 8.68301Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M11.27 22.97C11.27 23.5831 10.773 24.08 10.16 24.08C9.54694 24.08 9.04998 23.5831 9.04998 22.97C9.04998 22.357 9.54694 21.86 10.16 21.86C10.773 21.86 11.27 22.357 11.27 22.97Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M22.68 24.08C23.293 24.08 23.79 23.5831 23.79 22.97C23.79 22.357 23.293 21.86 22.68 21.86C22.0669 21.86 21.57 22.357 21.57 22.97C21.57 23.5831 22.0669 24.08 22.68 24.08Z",
        fill: "currentColor"
      }
    )
  );
};
CartEmptyIcon.iconName = "CartEmptyIcon";

export { CartEmptyIcon };
